import styled from 'styled-components'

export default styled.div`
  padding: 40px 0 20px;
  display: flex;
  justify-content: ${props => props.justifyContent || 'center'};
`
